import { render, staticRenderFns } from "./ipa.vue?vue&type=template&id=45262880"
import script from "./ipa.vue?vue&type=script&lang=js"
export * from "./ipa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports